import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ LIST ATTRIBUTE MAPPINGS
 * Optionally filter by AttributeDefinitionId or TaxonomyDetailRowId.
 * Targets: DeclrAttributeMappingController.list (Corp.usp_Z_13_Declr_AttributeMapping_List)
 */
export const fetchAttributeMappings = async ({ attributeDefinitionId, taxonomyDetailRowId } = {}, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-mapping/list",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({
                AttributeDefinitionId: attributeDefinitionId || null,
                TaxonomyDetailRowId: taxonomyDetailRowId || null,
            })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Declr Attribute Mapping List Failed:", err);
        return [];
    }
};

/**
 * 🛰️ ADD/SUPERSEDE ATTRIBUTE MAPPING
 * Targets: DeclrAttributeMappingController.add (Corp.usp_Z_13_Declr_AttributeMapping_Add)
 */
export const addAttributeMapping = async (mapping, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-mapping/add",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi(mapping)
        );
        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not save mapping.");
        return res.data;
    } catch (err) {
        console.error("Declr Attribute Mapping Add Error:", err);
        throw err;
    }
};

/**
 * 🛰️ REMOVE ATTRIBUTE MAPPING
 * Targets: DeclrAttributeMappingController.remove (Corp.usp_Z_13_Declr_AttributeMapping_Remove)
 */
export const removeAttributeMapping = async (attributeMappingId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-mapping/remove",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({ AttributeMappingId: attributeMappingId })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not remove mapping.");
        return true;
    } catch (err) {
        console.error("Declr Attribute Mapping Remove Error:", err);
        throw err;
    }
};

/**
 * 🛰️ LIST AGGREGATION METHODS
 * Targets: DeclrAttributeMappingController.ListAggregationMethods (Ref.usp_GetESG_AggregationMethod_List)
 */
export const fetchAggregationMethods = async (config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-mapping/aggregation-method/list",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({})
        );
        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Aggregation Method List Failed:", err);
        return [];
    }
};

/**
 * 🛰️ CALCULATE GROUP DECLARATION (roll-up preview)
 * Targets: DeclrAttributeMappingController.CalculateGroupDeclaration (Corp.usp_Z_13_Declr_GroupDeclaration_Calculate)
 */
export const calculateGroupDeclaration = async (corporateEntityId, reportingYear, taxonomyDetailRowId, config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/declr-attribute-mapping/group-declaration/calculate",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi({
                CorporateEntityId: corporateEntityId,
                ReportingYear: reportingYear,
                TaxonomyDetailRowId: taxonomyDetailRowId,
            })
        );
        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Could not calculate roll-up.");
        return res.data;
    } catch (err) {
        console.error("Group Declaration Calculate Error:", err);
        throw err;
    }
};
